import reduce  from './reducers/index';
import routes from '../routes';
import * as onboardingAction from './actions';
import * as onboardingOperation from './operations';
import * as onboardingSelector from './selectors';

export {
    onboardingAction,
    onboardingOperation,
    onboardingSelector,
}

export default {
    routes,
    reduce,
}